import React, { Component } from "react";
import { Container, Row, Col, Card, CardBody, Button } from "reactstrap";
import { api_route } from "../../Api-config/config";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//Import Components
import MiniWidgets from "./MiniWidgets";
import RevenueAnalytics from "./RevenueAnalytics";
import SalesAnalytics from "./SalesAnalytics";
import EarningReports from "./EarningReports";
import Sources from "./Sources";
import LatestNews from "./LatestNews";
import RevenueByLocations from "./RevenueByLocations";
import ChatBox from "./ChatBox";
import LatestTransactions from "./LatestTransactions";

import "./dashboard.scss";

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      breadcrumbItems: [
        { title: "Delisted Stocks", link: "#" },
        { title: "Dashboard", link: "#" },
      ],
      reports: [
        {
          icon: "ri-stack-line",
          title: "Number of Transactions This Month",
          value: "10",
          rate: "2.4%",
          desc: "From previous period",
        },
        {
          icon: "ri-store-2-line",
          title: "Total Transactions",
          value: "80",
          rate: "2.4%",
          desc: "From previous period",
        },

        // { icon : "ri-briefcase-4-line", title : "Average Price", value : "$ 15.4", rate : "2.4%", desc : "From previous period" },
      ],
      tableData: [],
    };
  }

  componentDidMount() {
    this.fetchDashData();
  }

  fetchDashData = () => {
    fetch(api_route + "/user/dashData", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify({
        id: sessionStorage.getItem("username"),
      }),
    })
      .then((response) => response.json())
      .then((json) => {
        this.setState({ tableData: json });

        console.log(json);
      });
  };

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs
              title="Dashboard"
              breadcrumbItems={this.state.breadcrumbItems}
            />
            <Row>
              <Col xl={8}>
                <Row>
                  <MiniWidgets
                    tableData={this.state.tableData}
                    reports={this.state.reports}
                  />
                  <LatestNews />
                </Row>

                {/* revenue Analytics */}

                {/* <RevenueAnalytics/> */}
              </Col>

              <Col xl={4}>
                {/* sales Analytics */}

                {/* earning reports */}
                <Card>
                  <CardBody>
                    <h4 className="card-title mb-4 text-center">
                      Join Telegram
                    </h4>
                    <div>
                      <Row>
                        <div
                          style={{
                            position: "relative",
                            left: "50%",
                            transform: "translate(-50%, 0)",
                          }}
                        >
                          <div className="mb-3 ">
                            <img src="https://img.icons8.com/fluency/64/000000/telegram-app.png" />
                          </div>
                          <Button
                            className="text-center ml-2"
                            style={{
                              background: "#229ED9",
                              color: "#229ED9",
                            }}
                          >
                            Join
                          </Button>
                        </div>
                      </Row>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            <Row>
              {/* sources */}
              {/* <Sources/> */}

              {/* recent activity */}

              {/* revenue by locations */}
              {/* <RevenueByLocations/> */}
            </Row>

            <Row>
              {/* chat box */}
              {/* <ChatBox/> */}

              {/* latest transactions */}
              {/* <LatestTransactions/> */}
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default Dashboard;
